<template>
    <v-hover>
        <v-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="cursor-pointer"
            :key="screener.id"
            style="height: 100%"
            @click.stop="$emit('goToScreenerOverview', screener.id)"
        >
        <!-- Show thumbnail of screener -->
        <v-img
            v-if="screener.thumbnail_url"
            class="white--text"
            :aspect-ratio="16/9"
            :src="screener.thumbnail_url"
        >
            <!-- Reserved checkmark -->

            <v-container
            v-if="isConsumerEnrolled(screener.id)"
            fill-height
            fluid
            pa-0
            class="overlay"
            >
            <v-tooltip top color="primary">
                <template v-slot:activator="{ on }">
                <v-layout
                    v-on="on"
                    column
                    wrap
                    fill-height
                    justify-center
                    align-center
                >
                    <!-- <v-flex xs12> -->
                    <v-icon color="success" size="58"
                    >mdi-checkbox-marked-circle-outline</v-icon
                    >
                    <h2 class="success--text">
                    {{ $t(`${eventPrefix}.reserved.title`) }}
                    </h2>
                    <!-- </v-flex> -->
                </v-layout>
                </template>
                <span class="background--text text--darken-3 body-1">
                {{ $t(`${eventPrefix}.reserved.tooltip`) }}
                </span>
            </v-tooltip>
            </v-container>
        </v-img>
        <!-- Show thumbnail of first film if thumbnail is not available on screener -->
        <v-img
            v-else-if="screener.films[0].thumburls"
            class="white--text"
            :aspect-ratio="16/9"
            :src="screener.films[0].thumburls"
        >
            <!-- Reserved checkmark -->

            <v-container
            v-if="isConsumerEnrolled(screener.id)"
            fill-height
            fluid
            pa-0
            class="overlay"
            >
            <v-tooltip top color="primary">
                <template v-slot:activator="{ on }">
                <v-layout
                    v-on="on"
                    column
                    wrap
                    fill-height
                    justify-center
                    align-center
                >
                    <!-- <v-flex xs12> -->
                    <v-icon color="success" size="58"
                    >mdi-checkbox-marked-circle-outline</v-icon
                    >
                    <h2 class="success--text">
                    {{ $t(`${eventPrefix}.reserved.title`) }}
                    </h2>
                    <!-- </v-flex> -->
                </v-layout>
                </template>
                <span class="background--text body-1">
                {{ $t(`${eventPrefix}.reserved.tooltip`) }}
                </span>
            </v-tooltip>
            </v-container>
        </v-img>
        <v-card-title>
            <div>
            <div class="pb-2" v-if="!is_vod">
                <span
                v-if="screener.is_vod_event"
                class="secondary--text text--lighten-2"
                >
                <span
                    v-if="
                    isConsumerEnrolled(screener.id) &&
                        vodEventStartTime(screener.id)
                    "
                >
                    {{
                    moment
                        .utc(vodEventStartTime(screener.id))
                        .local()
                        .format("lll")
                    }}
                </span>

                <span v-if="screener.venue" class="px-1"
                    >|&nbsp;</span
                >
                <span>{{ screener.venue[currentLocale] }}</span>
                </span>
                <span v-else class="secondary--text text--lighten-2">
                <span
                    v-if="
                    isConsumerEnrolled(screener.id) &&
                        isConsumerEnrolled
                    "
                ></span>
                {{
                    moment
                    .utc(screener.screening_starts_at)
                    .local()
                    .format("lll")
                }}
                <span class="px-1" v-if="screener.venue"
                    >|&nbsp;</span
                >
                <span>{{ screener.venue[currentLocale] }}</span>
                </span>
                <!-- Alert for geo-blocking -->
                <v-tooltip
                top
                v-if="screener.is_geo_blocked"
                color="primary"
                >
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="error" class="px-1"
                    >mdi-alert</v-icon
                    >
                </template>
                <span class="background--text body-1">
                    {{ $t(`${eventPrefix}.geo_blocked`) }}
                </span>
                </v-tooltip>
            </div>
            <div
                v-if="
                screener.is_vod_event &&
                    isConsumerEnrolled(screener.id)
                "
            >
                <v-chip
                v-if="isVodEventExpired(screener.id)"
                small
                color="error"
                text-color="white"
                >{{ $t("vod_event.expired") }}</v-chip
                >
                <v-chip
                v-if="isVodEventActive(screener.id)"
                small
                color="success"
                text-color="white"
                >{{ $t("vod_event.active") }}</v-chip
                >
            </div>
            <span
                style="line-height: 1.35 !important"
                class='title mb-1 cursor-pointer underline-on-hover secondary--text'
                @click.stop="$emit('goToScreenerOverview', screener.id)"
                >
                <!-- {{ eventTitile }} -->
                {{ screener.title[currentLocale] }}
            </span>
            <!-- Show "Purchased" mark if purchased but not enrolled  -->
            <PurchasedIndicator
                v-if="
                isConsumerPurchased(screener.id) &&
                    !isConsumerEnrolled(screener.id)
                "
                :eventPrefix="eventPrefix"
            ></PurchasedIndicator>
            <!-- Seats Status -->
            <div
                v-if="
                !screener.is_vod_event &&
                    !isArchiveMenu &&
                    !isConsumerEnrolled(screener.id) &&
                    !is_past
                "
            >
                <div>
                <span class="subheading secondary--text text--lighten-2"
                >{{ $t(`${eventPrefix}.seats.title`) }}
                </span>
                <span
                    class="subheading"
                    v-html="getSeatsStatus(screener)"
                ></span>
                </div>
                <span
                v-if="
                    !screener.is_vod_event &&
                    screener.event_type >
                        DEFINES.SCREENER_TYPE_VALUE.VIRTUAL
                "
                ><v-chip
                    small
                    outline
                    color="primary"
                    class="my-0 ml-1"
                    ><span class="body-2">{{
                    $t(DEFINES.SCREENER_TYPE_STR[screener.event_type])
                    }}</span></v-chip
                >
                </span>
            </div>
            </div>
        </v-card-title>
        </v-card>
    </v-hover>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PurchasedIndicator from "@/components/screener/PurchasedIndicator";
import { getSeatsStatus } from "@/mixins/screening";

export default {
    name: 'ScreenerListItem',
    mixins: [getSeatsStatus],
    props: {
        screener:{
            type: Object,
            required: true
        },
        is_past: {
            type: Boolean,
            default: false,
            },
        is_vod: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        PurchasedIndicator
    },
    computed: {
        ...mapState({
            currentCompany: (state) => state.company.company,
        }),
        ...mapGetters("consumer", {
            isConsumerEnrolled: "isEnrolled",
            isConsumerPurchased: "isPurchased",
            vodEventStartTime: "getVodEventStartTime",
            vodEventEndTime: "getVodEventEndTime",
            isVodEventExpired: "isVodEventExpired",
            isVodEventActive: "isVodEventActive",
        }),
        isArchiveMenu: function() {
            return this.$route.name == "screeners.archive";
        },
        eventPrefix() {
            return this.$route.name == "vod.movies" ? "vod" : "screener";
        },
        currentLocale() {
            return this.$i18n.locale;
        }
    },
    data() {
        return {
            // Define your component data here
        };
    },
    methods: {
        // Define your component methods here
    },
    
};
</script>

